import React from 'react';
import { BottomNavigation, BottomNavigationAction, Drawer, List, ListItem, ListItemText } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import EuroIcon from '@material-ui/icons/Euro';
import PeopleIcon from '@material-ui/icons/People';
import ContactsIcon from '@material-ui/icons/Contacts';

const DashboardMobileNav = ({
  classes,
  footerValue,
  handleFooterNav,
  activeSheet,
  closeSheet,
  goTo,
  translate,
  config
}) => {
  return (
    <>
      <nav className={classes.mobileFooterNav} aria-label="Primar navigering">
        <BottomNavigation
          value={footerValue}
          onChange={(event, value) => handleFooterNav(value)}
          showLabels
        >
          <BottomNavigationAction
            label={translate('', 'menu_home')}
            value="home"
            icon={<HomeIcon />}
          />
          <BottomNavigationAction
            label={translate('', 'menu_user_view_invoices')}
            value="invoices"
            icon={<EuroIcon />}
          />
          <BottomNavigationAction
            label={translate('', 'menu_user_my_info')}
            value="info"
            icon={<PeopleIcon />}
          />
          <BottomNavigationAction
            label={translate('', 'menu_user_contacts')}
            value="contacts"
            icon={<ContactsIcon style={{ fontSize: 18, marginBottom: 2 }} />}
            id="dashboard-mobile-nav-contacts"
          />
        </BottomNavigation>
      </nav>

      <Drawer
        anchor="bottom"
        open={Boolean(activeSheet)}
        onClose={closeSheet}
        classes={{ paper: classes.mobileSheetPaper }}
        ModalProps={{ keepMounted: true }}
      >
        <div className={classes.mobileSheetHandle} />

        <List>
          {activeSheet === 'invoices' && (
            <>
              <ListItem button onClick={() => { closeSheet(); goTo('/stel-invoices'); }}>
                <ListItemText primary={translate('', 'menu_user_view_stel_invoices')} />
              </ListItem>
              <ListItem button onClick={() => { closeSheet(); goTo('/supplier-invoices'); }}>
                <ListItemText primary={translate('', 'menu_user_view_supplier_invoices')} />
              </ListItem>
            </>
          )}

          {activeSheet === 'info' && (
            <>
              <ListItem button onClick={() => { closeSheet(); goTo('/my-info'); }}>
                <ListItemText primary={translate('', 'menu_user_my_info')} />
              </ListItem>
              <ListItem button onClick={() => { closeSheet(); goTo('/general-info'); }}>
                <ListItemText primary={translate('', 'menu_user_general_info')} />
              </ListItem>
              <ListItem button onClick={() => { closeSheet(); goTo('/smart-usage'); }}>
                <ListItemText primary={translate('', 'menu_user_use_electricity_smarter')} />
              </ListItem>
              {config.show_power_consumption_page && (
                <ListItem button onClick={() => { closeSheet(); goTo('/usage'); }}>
                  <ListItemText primary={translate('', 'menu_user_electricity_usage')} />
                </ListItem>
              )}
            </>
          )}
        </List>
      </Drawer>
    </>
  );
};

export default DashboardMobileNav;